import { Service } from "../../config/service";

class CadastroVeiculoService extends Service {

    constructor() {
        super("vehicles")
    }

    async listRascunho(config = {}) {
        try {
            const response = await this.http84.get(`${this.getResource().list}/list-draft`, { params: this.getParams(), ...config })
            return Promise.resolve(response)
        } catch (e) {
            this.setError(e)
            return Promise.reject(this.getError())
        }
    }
}

export default CadastroVeiculoService
